// Which brand is this hostname serving?
//
// One Firebase project, one set of accounts, one codebase. Only the skin and the
// legal/contact copy change per hostname, so a student who buys from both brands
// keeps ONE account and sees both courses on the same dashboard.
//
// Palettes: DEW-OS/references/brand.md (dewviko) และ brand-aisthetics.md (ai-sthetics)

export type BrandId = "dewviko" | "aisthetics";

export type Brand = {
  id: BrandId;
  /** ชื่อที่ใช้ใน title, footer, terms, privacy */
  name: string;
  site: { label: string; url: string };
  contactEmail: string;
};

const BRANDS: Record<BrandId, Brand> = {
  dewviko: {
    id: "dewviko",
    name: "Dewviko School",
    site: { label: "dewviko.com", url: "https://dewviko.com" },
    contactEmail: "dewviko@scalevdo.com",
  },
  aisthetics: {
    id: "aisthetics",
    name: "AI-Sthetics",
    site: { label: "ai-sthetics.com", url: "https://ai-sthetics.com" },
    contactEmail: "admin@scalevdo.com",
  },
};

/** `?brand=aisthetics` ใช้ดูอีกแบรนด์ตอน dev บน localhost ได้โดยไม่ต้องแก้ host file */
export function resolveBrandId(hostname: string, search = ""): BrandId {
  const forced = new URLSearchParams(search).get("brand");
  if (forced === "aisthetics" || forced === "dewviko") return forced;
  return hostname.includes("ai-sthetics") ? "aisthetics" : "dewviko";
}

/** Chat โลก + leaderboard are Dewviko-only (Dew, 2026-10-18): AI-sthetics runs its community on Skool. */
export function hasCommunity(id: BrandId): boolean {
  return id === "dewviko";
}

export const brand: Brand =
  BRANDS[
    typeof location === "undefined"
      ? "dewviko"
      : resolveBrandId(location.hostname, location.search)
  ];
